/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const cloud_sync_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cloud_sync_medium_svg__a)">
      <path
        fill="#000"
        d="m5.066 7.087.14.737-.14-.737Zm3.06 1.233a.75.75 0 1 0 .748-1.3l-.748 1.3ZM9.2 17.75a.75.75 0 0 0 0-1.5v1.5Zm9.013-8.972a.75.75 0 0 0 1.488.186l-1.488-.186Zm-6.38 6.746a.75.75 0 0 0 1.416.494l-1.416-.494ZM22.46 16l-.709.247.176.503h.533V16Zm.708 3.476a.75.75 0 0 0-1.417-.494l1.417.494ZM12.54 19l.708-.247-.175-.503h-.533V19Zm10.209-3v.75a.75.75 0 0 0 .75-.75h-.75Zm.75-3.25a.75.75 0 0 0-1.5 0h1.5Zm-4 2.5a.75.75 0 0 0 0 1.5v-1.5Zm-4 4.5a.75.75 0 0 0 0-1.5v1.5ZM12.25 19v-.75a.75.75 0 0 0-.75.75h.75Zm-.75 3.25a.75.75 0 0 0 1.5 0h-1.5Zm-5.5-6A4.25 4.25 0 0 1 1.75 12H.25A5.75 5.75 0 0 0 6 17.75v-1.5ZM1.75 12a4.252 4.252 0 0 1 3.456-4.176L4.927 6.35A5.752 5.752 0 0 0 .25 12h1.5Zm4.062-4.828C6.195 3.822 9.184 1.75 12 1.75V.25c-3.456 0-7.195 2.528-7.679 6.752l1.49.17Zm-.606.652a4.301 4.301 0 0 1 2.92.496l.748-1.3a5.801 5.801 0 0 0-3.947-.67l.279 1.474ZM6 17.75h3.2v-1.5H6v1.5Zm6-16c4.092 0 6.637 3.644 6.213 7.028l1.488.186C20.223 4.8 17.106.25 12 .25v1.5Zm1.25 14.268A4.502 4.502 0 0 1 17.5 13v-1.5a6.002 6.002 0 0 0-5.667 4.024l1.416.494ZM17.5 13c1.915 0 3.62 1.438 4.25 3.247l1.417-.494c-.799-2.291-2.995-4.253-5.667-4.253V13Zm4.25 5.982A4.502 4.502 0 0 1 17.5 22v1.5a6.002 6.002 0 0 0 5.667-4.024l-1.417-.494ZM17.5 22c-1.915 0-3.62-1.438-4.25-3.247l-1.417.494c.799 2.291 2.995 4.253 5.667 4.253V22Zm6-6v-3.25H22V16h1.5Zm-.75-.75H19.5v1.5h3.25v-1.5Zm-7.25 3h-3.25v1.5h3.25v-1.5Zm-4 .75v3.25H13V19h-1.5Zm10.959-2.25h.291v-1.5h-.291v1.5Zm-9.918 1.5h-.291v1.5h.291v-1.5Z"
      />
    </g>
    <defs>
      <clipPath id="cloud_sync_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cloud_sync_medium
